const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de detalle de orden',
  PAGE_DESCRIPTION:
    'Aquí puedes visualizar toda la información relevante de una orden en específico de manera ordenada y clara. Tambien en la parte derecha cuentas con un botón de "Opciones" para realizar mas acciones con respecto a la orden seleccionada',
  DEFAULT_WAREHOUSE_COUNTRY: 'México'
};

export default HELPER_TEXTS;
